var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',_vm._b({ref:"lineChart",attrs:{"data":_vm.localeData,"enable-resize":"vertical","loading":_vm.loading}},'line-chart',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }